import React, { Component } from 'react';
import Card from '../../components/Card';
import CardHeader from '../../components/CardHeader';
import MarketList from './components/MarketList';
import Select from '../../components/Select';
import styled from 'styled-components';
import { I18n } from 'react-redux-i18n';

const RightComponents = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};

  .marketCardRightLabel {
    margin-right: 14px;
    font-size: 12px;
  }
`;

export default class Market extends Component {
  constructor(props) {
    super(props);
    this.state = {
      year: { value: new Date().getFullYear(), label: new Date().getFullYear() }
    };
  }

  makeOptions() {
    let { markets } = this.props;
    if (!markets) {
      markets = [];
    }
    let options = [...new Set(markets.map((item) => item.year))];
    options = options.sort();
    options = options
      .filter((option) => option <= new Date().getFullYear())
      .map((option) => ({ value: option, label: option }));
    return options;
  }

  filterMarkets(year) {
    let { markets, displayWineShop } = this.props;
    if (!markets) {
      markets = [];
    }
    markets = markets.filter(
      (market) =>
        market.year == year.value &&
        (market.network_code == 'ON' || market.network_code == 'OFF')
    );
    if (!displayWineShop) {
      markets = markets.filter((market) => market.network_code !== 'OFF');
    }
    return markets;
  }

  render() {
    const { year } = this.state;
    const filteredMarkets = this.filterMarkets(year);
    const options = this.makeOptions();
    return (
      <Card className="adminCard">
        <CardHeader
          textTransform="normal"
          title={I18n.t('admin.market')}
          icon="world"
          iconContainer
          iconPosition="left"
          rightComponents={
            <RightComponents>
              <span className="marketCardRightLabel">
                {I18n.t('admin.year')} :{' '}
              </span>
              <Select
                dropdownProps={{ styles: `margin-left:-25px` }}
                placeholder="2018"
                value={year}
                onChange={(selectedOption) =>
                  this.setState({ year: selectedOption })
                }
                options={options.sort().reverse()}
                style={{ minWidth: 100 }}
                customStyles={{
                  container: { width: 107, height: 45 },
                  control: { width: 107, height: 45 },
                  menu: { width: 107, minWidth: 100 }
                }}
              />
            </RightComponents>
          }
        />
        <div className="marketListContainer">
          <MarketList markets={filteredMarkets} />
        </div>
      </Card>
    );
  }
}
